import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  LinearProgress,
  Link,
  ListItemText,
  styled,
  TextField,
  Tooltip,
  Typography
} from '@mui/material'
import { Filter } from '../../../components/_WMS/FilterComponent'
import React, { Fragment, useState } from 'react'
import { useApi } from '../../../hooks/useApi'
import { Loading } from '../../../components/UI/Loading/Loading'
import { Status } from '../../../hooks/useFetchState'
import { getWorkOrderRecallTemplate, postWorkOrderRecall } from '../api'
import { WarehouseDDL } from '../../../components/Almacen'
import { ZoneDDL } from '../../../components/Zone'
import { ProductOriginsDDL } from '../../../components/Producto/ProductOrigins/ProductOriginsDDL'
import { HelpIcon } from '../../../components/_WMS/HelpIcon/HelpIcon'
import { eTypeStorage } from '../../../enums/eTypeStorage'

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
      height: 15,
      borderRadius: 5,
      '& .MuiLinearProgress-bar': {
        borderRadius: 5,
        backgroundColor: '#1a90ff'
      },
      backgroundColor: '#EEEEEE'
    }))

interface CreateWorkOrderRecallModalProps {
  handleSnackbar: (message: string, success: boolean) => void
  handleCloseModal: () => void
  requestWorkOrderRecall: (
    filters?: Filter[],
    page?: number,
    pageSize?: number
  ) => void
}

export const CreateWorkOrderRecallModal: React.FC<
  CreateWorkOrderRecallModalProps
> = ({ handleSnackbar, handleCloseModal, requestWorkOrderRecall }) => {
  const [currentFile] = useState<any | undefined>(
    undefined
  )
  const [progress, setProgress] = useState<number>(0)

  const [selectedFiles, setSelectedFiles] = useState<any[] | undefined>(
    undefined
  )

  const [promiseDate, setpromiseDate] = useState<string>('')
  const [comments, setComments] = useState<string>('')
  const [checkQuality, setCheckQuality] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [checkTotalSku, setCheckTotalSku] = useState(false)

  const { state: requestLabelState, callApi: requestDownloadTemplate } =
    useApi()
  const [selectedWarehouse, setSelectedWarehouse] = useState<number>(-1)
  const [selectedProductOrigins, setSelectedProductOrigins] =
    useState<number>(0)
  const [selectedZone, setSelectedZone] = useState<number>(-1)
  // const [zonesByWarehouse, setZonesByWarehouse] = useState<Zone[]>([])

  const { state, callApi } = useApi()

  const handleSetProductOrigin = (id: number) => {
    setSelectedProductOrigins(id)
  }

  const handleSetZone = (id: number) => {
    setSelectedZone(id)
  }

  const handleSetWarehouse = (id: number) => {
    setSelectedWarehouse(id)
    setSelectedZone(-1)
  }

  const handleChkQuality = () => {
    setCheckQuality(!checkQuality)
  }

  const handleChkTotalSku = () => {
    setCheckTotalSku(!checkTotalSku)
  }

  const handleDatePickerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setpromiseDate(e.target.value) // La fecha se maneja como string en formato YYYY-MM-DD
  }

  const handleCommentsChange = ({
    target: { value: userComments }
  }: React.ChangeEvent<HTMLInputElement>) => {
    setComments(userComments)
  }

  const handleSelectFile = (event: any) => {
    setSelectedFiles(event.target.files)
    setProgress(0)
  }

  const validateButtonLoad = () => {
    if (!selectedFiles || selectedWarehouse <= 0) return true
    else return false
  }

  const handleSubmit = () => {
    setLoading(true)

    const formData = new FormData()

    // Agregar los valores del formulario
    formData.append('productOriginId', `${selectedProductOrigins}`)
    formData.append('promiseDate', promiseDate)
    formData.append('zoneId', `${selectedZone}`)
    formData.append('isTotalSku', `${checkTotalSku}`)
    formData.append('isQualityControl', `${checkQuality}`)
    formData.append('comments', `${comments}`)

    // Agregar el archivo seleccionado
    if (selectedFiles && selectedFiles.length > 0)
      formData.append('file', selectedFiles[0])

    callApi(postWorkOrderRecall(formData))
      .then(() => {
        handleSnackbar('Carga realizada exitosamente', true)
        requestWorkOrderRecall()
        handleCloseModal()
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDownloadTemplate = () => {
    setLoading(true)

    requestDownloadTemplate(getWorkOrderRecallTemplate())
      .then((response) => {
        const raw = window.atob(response.file)
        const uInt8Array = new Uint8Array(raw.length)
        for (let i = 0; i < raw.length; ++i) {
          uInt8Array[i] = raw.charCodeAt(i)
        }
        const link = document.createElement('a')
        const blob = new Blob([uInt8Array], {
          type: response.mimeType
        })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', response.name)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch((error) => {
        handleSnackbar(error, false)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (state.status === Status.Loading || loading) {
    return (
      <div>
        <Typography>
          <Loading />
        </Typography>
      </div>
    )
  } else {
    return (
      <Fragment>
        <Grid
          container
          spacing={2}
          justifyContent='space-around'
          alignItems='flex-start'
          style={{ textAlign: 'center', marginBottom: '5px' }}
        >
          <Grid
            item
            xs={12}
            sm={4}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <ProductOriginsDDL
              onChange={(e: any) =>
                handleSetProductOrigin(e.target.value as number)
              }
              value={selectedProductOrigins}
              required={true}
              type='outlined'
              fullWidth
              typeStorages={[eTypeStorage.Interno, eTypeStorage.Mixto]}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <WarehouseDDL
              onChange={(e: any) =>
                handleSetWarehouse(e.target.value as number)
              }
              value={selectedWarehouse}
              required={true}
              type='outlined'
              fullWidth
            />
          </Grid>

          <Grid
            container
            item
            xs={12}
            sm={4}
            justifyContent='center'
            alignItems='center'
            alignContent='center'
            style={{ textAlign: 'center' }}
          >
            <Grid item xs={11}>
              <ZoneDDL
                value={selectedZone}
                onChange={(e: any) => handleSetZone(e.target.value as number)}
                warehouseId={selectedWarehouse}
                required={true}
                disabled={selectedWarehouse === -1}
                variant='outlined'
                fullWidth
                isExternal={false}
              />
            </Grid>
            <Grid
              item
              xs={1}
              direction='column'
              justifyContent='center'
              alignItems='center'
              alignContent='center'
            >
              <HelpIcon
                helperText='No se muestran zonas configuradas como externas'
                placement='bottom-end'
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <TextField
                id='promiseDate'
                name='promiseDate'
                label='Fecha Compromiso'
                type='date'
                value={promiseDate}
                onChange={handleDatePickerChange}
                variant='outlined'
                InputLabelProps={{
                  shrink: true
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  size='medium'
                  color='primary'
                  onChange={() => handleChkQuality()}
                />
              }
              label='Control de Calidad'
            />
          </Grid>
          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  size='medium'
                  color='primary'
                  onChange={() => handleChkTotalSku()}
                />
              }
              label='Totalidad de Productos'
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <TextField
                id='comments'
                name='comments'
                label='Comentarios'
                type='date'
                value={comments}
                onChange={handleCommentsChange}
                variant='outlined'
                InputLabelProps={{
                  shrink: true
                }}
                multiline
                minRows={3}
                maxRows={5}
              />
            </FormControl>
          </Grid>
        </Grid>
        <br />
        <hr />
        <Box className='mb25' display='flex' alignItems='center'>
          <Grid
            container
            spacing={4}
            direction='row'
            alignItems='center'
            justifyContent='center'
            style={{ justifyContent: 'center' }}
          >
            <Grid item xs={3} style={{ textAlign: 'right' }}>
              <label htmlFor='btn-upload'>
                <input
                  id='btn-upload'
                  name='btn-upload'
                  style={{ display: 'none' }}
                  type='file'
                  onChange={handleSelectFile}
                  accept='.xls,.xlsx'
                />
                <Tooltip
                  title='Seleccionar el archivo Excel a cargar'
                  placement='top-end'
                >
                  <Button
                    className='btn-choose'
                    variant='outlined'
                    component='span'
                  >
                    Seleccionar Archivo
                  </Button>
                </Tooltip>
              </label>
            </Grid>

            <Grid item xs={5}>
              <div className='file-name'>
                {selectedFiles && selectedFiles.length > 0
                  ? selectedFiles[0].name
                  : null}
              </div>
            </Grid>

            <Grid item xs={1}>
              <Tooltip
                title='Enviar el archivo seleccionado al servidor para su procesamiento'
                placement='top-end'
              >
                <Button
                  className='btn-upload'
                  color='primary'
                  variant='contained'
                  component='span'
                  disabled={validateButtonLoad()}
                  onClick={handleSubmit}
                >
                  Cargar
                </Button>
              </Tooltip>
            </Grid>

            <Grid
              item
              xs={1}
              alignContent='center'
              style={{ textIndent: '15px' }}
            >
              <HelpIcon
                helperText={
                  'Oprima el botón SELECCIONAR para elegir el archivo a subir y luego el botón CARGAR para enviar el archivo al servidor para su procesamiento'
                }
                placement='top-end'
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              style={{ padding: '0px', marginBottom: '25px' }}
            >
              <ListItemText
                primary={''}
                secondary={
                  <Box>
                    <Typography component='ol' style={{ listStyle: 'square' }}>
                      <Typography
                        variant='subtitle1'
                        component='li'
                        gutterBottom
                      >
                        Puede descargar una <b>plantilla</b> desde el link que
                        se encuentra disponible a continuación.
                        <br />
                        {requestLabelState.status === Status.Loading ? (
                          <Fragment>
                            <div>
                              <Typography>
                                <Loading />
                              </Typography>
                            </div>
                          </Fragment>
                        ) : (
                          <Link
                            style={{ cursor: 'pointer' }}
                            onClick={handleDownloadTemplate}
                          >
                            Descargar Template
                          </Link>
                        )}
                      </Typography>
                    </Typography>
                  </Box>
                }
              />
            </Grid>
          </Grid>
        </Box>

        <div
          style={{
            margin: '10px',
            visibility: currentFile ? 'visible' : 'hidden'
          }}
        >
          <BorderLinearProgress variant='determinate' value={progress} />

          <Box minWidth={35}>
            <Typography
              variant='body1'
              color='textSecondary'
              style={{ textAlign: 'end' }}
            >{`${progress}%`}</Typography>
          </Box>
        </div>
      </Fragment>
    )
  }
}
